import { render, staticRenderFns } from "./WidgetContacto.vue?vue&type=template&id=2aff81e7&lang=pug"
import script from "./WidgetContacto.vue?vue&type=script&lang=js"
export * from "./WidgetContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports